import { getWindowLocks, getWindowWERList } from "./../selectors";
import utils from "utils";
import { getDoorLocks, getDoorWERList } from "../selectors";

const getSizeBetweenMinMax = (value, min, max) => {
    if (value < min) {
        return min;
    }
    if (value > max) {
        return max;
    }
    return value;
};

const getWindowSize = (windowFormSize, windowDesignId, rootState) => {
    if (windowFormSize.Type === "approximate") {
        let SizeConfig = utils.getValueById(rootState.Window.Designs, windowDesignId);
        let defaultWidth = SizeConfig.defaultWidth;
        let defaultHeight = SizeConfig.defaultHeight;
        let coef = 1.0;

        switch (windowFormSize.Approximate) {
            case "small":
                coef = 0.8;
                break;
            case "large":
                coef = 1.5;
                break;
            default:
                coef = 1.0;
                break;
        }

        windowFormSize.Width = getSizeBetweenMinMax(
            defaultWidth * coef,
            SizeConfig.minWidth,
            SizeConfig.maxWidth
        );
        windowFormSize.Height = getSizeBetweenMinMax(
            defaultHeight * coef,
            SizeConfig.minHeight,
            SizeConfig.maxHeight
        );
        windowFormSize.Unit = "mm";
    }

    let actualWidth = windowFormSize.Width;
    let actualHeight = windowFormSize.Height;

    if (windowFormSize.Unit === "inch" && windowFormSize.Type !== "approximate") {
        actualWidth *= 25.4;
        actualHeight *= 25.4;
    }

    return {
        Display:
            windowFormSize.Type === "approximate"
                ? windowFormSize.Approximate
                : windowFormSize,
        Width: Math.round(actualWidth),
        Height: Math.round(actualHeight)
    };
};

const getConservatorySize = (conservatoryFormSize) => {
    let actualWidth = conservatoryFormSize.Width;
    let actualHeight = conservatoryFormSize.Height;

    if (conservatoryFormSize.Unit === "m") {
        actualWidth *= 1000;
        actualHeight *= 1000;
    }else if(conservatoryFormSize.Unit === "ft"){
        actualWidth *= 304.8;
        actualHeight *= 304.8;
    }

    return {
        Unit: "mm",
        Width: Math.round(actualWidth),
        Height: Math.round(actualHeight),
        UserSelected:{
            Unit: conservatoryFormSize.Unit,
            Width: conservatoryFormSize.Width,
            Height: conservatoryFormSize.Height,
        }
    };
};

const getNewDoorData = (doorForm, rootState) => {
    console.debug("doorForm", doorForm);
    console.debug("rootState", rootState);

    let result = {
        CreatedDate: new Date(),
        Quantity: 1
    };

    result.ItemType = {
        Id: rootState.ItemTypes.filter(m => m.name === "Door")[0].id,
        Name: "Door"
    };

    result.Room = {
        Id: doorForm.DoorRoomId,
        Name: utils.getValueById(rootState.Door.Rooms, doorForm.DoorRoomId).name
    };

    result.Type = {
        Id: doorForm.DoorTypeId,
        Name: utils.getValueById(rootState.Door.Types, doorForm.DoorTypeId).name
    };

    var efficiencyId = getDoorWERList(rootState).filter(wer => wer.name === "C")[0].Id;
    var efficiencyName = "C";

    // if we have any window, grab the efficiency details from it
    if (rootState.ProductList.some(p => p.ItemType.Name === "Window")) {
        efficiencyId = rootState.ProductList.filter(p => p.ItemType.Name === "Window")[0].Efficiency
            .Id;
        efficiencyName = utils.getValueById(getDoorWERList(rootState), efficiencyId).name;
    }

    result.Efficiency = {
        Id: efficiencyId,
        Name: efficiencyName,
        GlassTypeId: rootState.Door.Options.glass[0].id
    };

    result.Type.IsComposite = doorForm.IsComposite;
    result.Type.IsPatioOrBiFold = doorForm.IsPatioOrBiFold;

    if (result.Type.IsComposite) {
        // if we have selected some glass, replace the original style id
        if (doorForm.DoorGlassId) {
            doorForm.DoorStyleId = doorForm.DoorGlassId;
        }

        result.Style = {
            Id: doorForm.DoorStyleId,
            Name: utils.getValueById(rootState.Door.Styles, doorForm.DoorStyleId).name
        };

        result.Size = {
            Height: utils.getValueById(rootState.Door.Styles, doorForm.DoorStyleId).defaultHeight,
            Width: utils.getValueById(rootState.Door.Styles, doorForm.DoorStyleId).defaultWidth
        };

        var interiorColour = utils.getValueById(
            rootState.Door.Options.extras,
            doorForm.DoorInteriorColourId
        );
        var exteriorColour = utils.getValueById(
            rootState.Door.Options.extras,
            doorForm.DoorExteriorColourId
        );

        result.Colour = {
            Interior: {
                Id: doorForm.DoorInteriorColourId,
                Name: interiorColour.description1,
                ImageSrc: interiorColour.externalImageUrl1
            },
            Exterior: {
                Id: doorForm.DoorExteriorColourId,
                Name: exteriorColour.description1,
                ImageSrc: exteriorColour.externalImageUrl1
            }
        };

        let frameColourId = doorForm.DoorFrameColourInterior
            ? utils.getValueById(rootState.Door.Options.colours, doorForm.DoorFrameId)
                  .relatedColourId
            : doorForm.DoorFrameId;

        result.Frame = {
            Id: frameColourId,
            Name: utils.getValueById(rootState.Door.Options.colours, frameColourId).name,
            WhiteInterior: doorForm.DoorFrameColourInterior,
            ImageSrc: utils.getValueById(rootState.Door.Options.colours, doorForm.DoorFrameId)
                .externalImageUrl1
        };

        let handle = utils.getValueById(rootState.Door.Options.extras, doorForm.DoorHandleId);

        result.Handle = {
            Id: doorForm.DoorHandleId,
            Name: handle.description1 + " (" + handle.description2 + ")",
            Type: doorForm.DoorHandleType,
            ImageSrc: handle.externalImageUrl1
        };

        result.HasKnocker = doorForm.DoorKnockerId ? true : false;

        if (result.HasKnocker) {
            result.Knocker = {
                Id: doorForm.DoorKnockerId,
                Name: utils.getValueById(rootState.Door.Options.extras, doorForm.DoorKnockerId)
                    .name,
                ImageSrc: utils.getValueById(rootState.Door.Options.extras, doorForm.DoorKnockerId)
                    .externalImageUrl1
            };
        }

        result.HasLetterbox = doorForm.DoorLetterboxId ? true : false;

        if (result.HasLetterbox) {
            result.Letterbox = {
                Id: doorForm.DoorLetterboxId,
                Name: utils.getValueById(rootState.Door.Options.extras, doorForm.DoorLetterboxId)
                    .name,
                ImageSrc: utils.getValueById(
                    rootState.Door.Options.extras,
                    doorForm.DoorLetterboxId
                ).externalImageUrl1
            };
        }

        result.Glass = {
            Id: doorForm.DoorGlassId || doorForm.DoorStyleId,
            Name: utils.getValueById(
                rootState.Door.Styles,
                doorForm.DoorGlassId || doorForm.DoorStyleId
            ).name
        };

        result.FlattenedImageSrc = doorForm.FlattenedImageSrc;
        result.randomIdForImageReplacement = doorForm.randomIdForImageReplacement;
    } else {
        // uPVC

        result.Model = {
            Id: doorForm.DoorModelId,
            Name: utils.getValueById(rootState.Door.Models, doorForm.DoorModelId).name
        };


        let Width, Height;
        const defaultHeight = utils.getValueById(rootState.Door.Models, doorForm.DoorModelId).defaultHeight;

        let Unit = "mm";

        if (result.Type.IsPatioOrBiFold) {
            ({Unit} = doorForm.DoorSize);
            Width = Math.round(doorForm.DoorSize.Width);
            Height = Math.round(utils.convertWindowSize(defaultHeight, "mm", Unit));
        } else {
            Height = defaultHeight;
            Width = utils.getValueById(rootState.Door.Models, doorForm.DoorModelId).defaultWidth;
        }            
        
        result.Size = {
            Height,
            Width,
            Unit
        };

        result.Colour = {
            Id: doorForm.DoorColourInterior
                ? utils.getValueById(rootState.Door.Options.colours, doorForm.DoorColourId)
                      .relatedColourId
                : doorForm.DoorColourId,
            Name: utils.getValueById(rootState.Door.Options.colours, doorForm.DoorColourId).name,
            WhiteInterior: doorForm.DoorColourInterior,
            ImageSrc: utils.getValueById(rootState.Door.Options.colours, doorForm.DoorColourId)
                .externalImageUrl1
        };

        let handle = utils.getValueById(rootState.Door.Options.extras, doorForm.DoorHandleId);

        result.Handle = {
            Id: doorForm.DoorHandleId,
            Name: handle.description1 || handle.name,
            Type: doorForm.DoorHandleType,
            AtkLock: doorForm.DoorAtkLock,
            ImageSrc: handle.externalImageUrl1
        };

        result.HasLetterbox = doorForm.DoorLetterboxId ? true : false;

        if (result.HasLetterbox) {
            result.Letterbox = {
                Id: doorForm.DoorLetterboxId,
                Name: utils.getValueById(rootState.Door.Options.extras, doorForm.DoorLetterboxId)
                    .name,
                ImageSrc: utils.getValueById(
                    rootState.Door.Options.extras,
                    doorForm.DoorLetterboxId
                ).externalImageUrl1
            };
        }

        let locks = getDoorLocks(rootState);

        if (locks.length === 1) {
            result.HasLock = true;
            result.Lock = {
                Id: locks[0].id,
                Name: locks[0].name
            };
        } else if (locks.length === 2) {
            let lock;

            lock = locks.filter(
                lock =>
                    (doorForm.DoorAtkLock && lock.isUpgrade) ||
                    (!doorForm.DoorAtkLock && !lock.isUpgrade)
            )[0];

            result.HasLock = true;
            result.Lock = {
                Id: lock.id,
                Name: lock.name
            };
        } else {
            result.HasLock = false;
            result.Lock = {};
        }

        result.FlattenedImageSrc = utils.getValueById(
            rootState.Door.Types,
            doorForm.DoorTypeId
        ).externalImageUrl;

        result.randomIdForImageReplacement = doorForm.randomIdForImageReplacement;
    }

    result.Name =
        result.Room.Name +
        " " +
        (rootState.ProductList.filter(p => p.Room && p.Room.Id === result.Room.Id).length + 1);

    console.debug("NEW DOOR", result);

    return result;
};

const getNewWindowData = (windowForm, rootState) => {
    console.debug("windowForm", windowForm);
    console.debug("rootState", rootState);

    let result = {
        CreatedDate: new Date(),
        Quantity: 1
    };

    result.ItemType = {
        Id: rootState.ItemTypes.filter(m => m.name === "Window")[0].id,
        Name: "Window"
    };

    result.Room = {
        Id: windowForm.WindowRoomId,
        Name: utils.getValueById(rootState.Window.Rooms, windowForm.WindowRoomId).name
    };

    result.Style = {
        Id: windowForm.WindowStyleId,
        Name: utils.getValueById(rootState.Window.Styles, windowForm.WindowStyleId).name
    };

    result.Size = getWindowSize(windowForm.WindowSize, windowForm.WindowDesignId, rootState);

    let selectedDesign = utils.getValueById(rootState.Window.Designs, windowForm.WindowDesignId);

    result.Design = {
        Id: windowForm.WindowDesignId,
        Name: selectedDesign.name
    };

    result.Colour = {
        Id: windowForm.WindowColourInterior
            ? utils.getValueById(rootState.Window.Options.colours, windowForm.WindowColourId)
                  .relatedColourId
            : windowForm.WindowColourId,
        Name: utils.getValueById(rootState.Window.Options.colours, windowForm.WindowColourId).name,
        WhiteInterior: windowForm.WindowColourInterior,
        ImageSrc: utils.getValueById(rootState.Window.Options.colours, windowForm.WindowColourId)
            .externalImageUrl1
    };

    if (selectedDesign.openingsCount !== 0) {
        let handle = utils.getValueById(rootState.Window.Options.extras, windowForm.WindowHandleId);

        result.HasHandle = true;
        result.Handle = {
            Id: windowForm.WindowHandleId,
            Name: handle.description1 || handle.name,
            ImageSrc: handle.externalImageUrl1
        };
    } else {
        result.HasHandle = false;
        result.Handle = {};
    }

    let locks = getWindowLocks(rootState);

    if (locks.length === 1 && selectedDesign.openingsCount !== 0) {
        result.HasLock = true;
        result.Lock = {
            Id: locks[0].id,
            Name: locks[0].name
        };
    } else if (locks.length === 2 && selectedDesign.openingsCount !== 0) {
        let lock;

        lock = locks.filter(
            lock =>
                (windowForm.YaleLock && lock.isUpgrade) ||
                (!windowForm.YaleLock && !lock.isUpgrade)
        )[0];

        result.HasLock = true;
        result.Lock = {
            Id: lock.id,
            Name: lock.name
        };
    } else {
        result.HasLock = false;
        result.Lock = {};
    }

    if (!windowForm.WindowEfficiencyId) {
        windowForm.WindowEfficiencyId = rootState.ProductList.filter(
            p => p.ItemType.Name === "Window"
        )[0].Efficiency.Id;
    }

    result.Efficiency = {
        Id: windowForm.WindowEfficiencyId,
        Name: utils.getValueById(getWindowWERList(rootState), windowForm.WindowEfficiencyId).name,
        GlassTypeId: rootState.Window.Options.glass[0].id
    };

    result.FlattenedImageSrc = utils.getValueById(
        rootState.Window.Styles,
        windowForm.WindowStyleId
    ).externalImageUrl;

    result.Name =
        result.Room.Name +
        " " +
        (rootState.ProductList.filter(p => p.Room && p.Room.Id === result.Room.Id).length + 1);

    console.debug("NEW WINDOW", result);

    result.randomIdForImageReplacement = Math.floor(1e10 * Math.random());

    return result;
};

const getNewAdditionalData = (additionalForm, rootState) => {

    let result = {
        CreatedDate: new Date(),
        Quantity: 1,
    };


    result.ItemType = {
        Id: rootState.ItemTypes.find(m=>m.name === "Additional").id,
        Name: "Additional"
    };

    result.Type = {
        Id: additionalForm.additionalTypeId,
        Name: utils.getValueById(rootState.Additional.Types, additionalForm.additionalTypeId).name
    };

    result.Name = result.Type.Name + " " + (rootState.ProductList.filter(p => p.Type && p.Type.Id === result.Type.Id).length + 1);

    result.FlattenedImageSrc = utils.getValueById(rootState.Additional.Types, additionalForm.additionalTypeId).externalImageUrl;

    return result;
};

const getNewConservatoryData = (conservatoryForm, rootState) => {
    console.debug("conservatoryForm", conservatoryForm);
    console.debug("rootState", rootState);

    let result = {
        CreatedDate: new Date(),
        Quantity: 1
    };

    result.ItemType = {
        Id: rootState.ItemTypes.filter(m => m.name === "Conservatory")[0].id,
        Name: "Conservatory"
    };

    result.Type = {
        Id: conservatoryForm.ConservatoryId,
        Name: utils.getValueById(rootState.Conservatory.Types, conservatoryForm.ConservatoryId).name
    };
    
    result.Style = {
        Id: conservatoryForm.ConservatoryTypeId,
        Name: utils.getValueById(rootState.Conservatory.Styles, conservatoryForm.ConservatoryTypeId).name,
        Image: utils.getValueById(rootState.Conservatory.Styles, conservatoryForm.ConservatoryTypeId).externalImageUrl
    };

    result.Size = getConservatorySize(conservatoryForm.ConservatorySize);

    let selectedRoof = utils.getValueById(rootState.Conservatory.Extras.extras, conservatoryForm.ConservatoryRoofMaterialId);

    result.Design = {
        Id: conservatoryForm.ConservatoryRoofMaterialId,
        Name: selectedRoof.name
    };

    result.Colour = {
        Id: conservatoryForm.ConservatoryColourInterior
            ? utils.getValueById(rootState.Conservatory.Extras.colours, conservatoryForm.ConservatoryColourId)
                  .relatedColourId
            : conservatoryForm.ConservatoryColourId,
        Name: utils.getValueById(rootState.Conservatory.Extras.colours, conservatoryForm.ConservatoryColourId).name,
        WhiteInterior: conservatoryForm.ConservatoryColourInterior,
        ImageSrc: utils.getValueById(rootState.Conservatory.Extras.colours, conservatoryForm.ConservatoryColourId)
            .externalImageUrl1
    };

    result.FlattenedImageSrc = conservatoryForm.FlattenedImageSrc;

    result.Name =
        result.Type.Name +
        " " +
        (rootState.ProductList.filter(p => p.Type && p.Type.Id === result.Type.Id).length + 1);

    result.randomIdForImageReplacement = conservatoryForm.randomIdForImageReplacement;

    return result;
};

const updateExistingDoorEfficiency = productList => {
    var windows = productList.filter(p => p.ItemType.Name === "Window");

    // if don't have a single window, no changes
    if (!windows.length === 1) return productList;

    var windowEfficiency = windows[0].Efficiency;

    return productList.map(product => {
        // if the product has efficiency, keep as-is
        if(product.Efficiency){
            if (product.Efficiency.Id === windowEfficiency.Id) return product;
        }else if(product.Type){
            return product;
        }

        return {
            ...product,
            Efficiency: {
                ...product.Efficiency,
                Id: windowEfficiency.Id,
                Name: windowEfficiency.Name
            }
        };
    });
};

export default function(state = [], action, rootState) {
    switch (action.type) {
        case "ADD_DOOR_TO_LIST":
            return [...state, getNewDoorData(action.payload, rootState)];
        case "ADD_WINDOW_TO_LIST":
            var newState = [...state, getNewWindowData(action.payload, rootState)];
            // update all doors efficiency if efficiency was selected
            return updateExistingDoorEfficiency(newState);
        case "ADD_CONSERVATORY_TO_LIST":
            return [...state, getNewConservatoryData(action.payload, rootState)];
        case "ADD_ADDITIONAL_TO_LIST":
            return [...state, getNewAdditionalData(action.payload, rootState)];
        case "DELETE_PRODUCT":
            return [
                ...state.slice(0, action.payload.index),
                ...state.slice(action.payload.index + 1)
            ];
        case "CHANGE_QUANTITY_PRODUCT":
            var product = state[action.payload.index];
            var newProduct = { ...product, Quantity: action.payload.value };
            return [
                ...state.slice(0, action.payload.index),
                newProduct,
                ...state.slice(action.payload.index + 1)
            ];
        case "LOAD_FLAT_IMAGE":
            var productIndex = state.findIndex(
                p => p.randomIdForImageReplacement === action.payload.randomIdForImageReplacement
            );

            var productWithImg = {
                ...state[productIndex],
                FlattenedImageSrc: action.payload.imgUrl
            };

            return [
                ...state.slice(0, productIndex),
                productWithImg,
                ...state.slice(productIndex + 1)
            ];
        case "LOAD_SVG_IMAGE":
            var productSvgIndex = state.findIndex(
                p => p.randomIdForImageReplacement === action.payload.randomIdForImageReplacement
            );
            // if we couldn't find one, ignore this action
            if (productSvgIndex < 0) {
                return state;
            }

            var productWithSvg = {
                ...state[productSvgIndex],
                SvgImage: action.payload.data,
                randomIdForImageReplacement: null
            };

            return [
                ...state.slice(0, productSvgIndex),
                productWithSvg,
                ...state.slice(productSvgIndex + 1)
            ];
        case "LOAD_QUOTE":
            return [...action.payload];
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/productList_reducer.js